import $ from 'jquery';
import Swiper from 'swiper';
import {Navigation, EffectCoverflow} from 'swiper/modules';
import {Dialog} from '../Libraries/Dialog';


$('.gallery-slider').each((i, elem) => {
    const $root = $(elem);
    const $slider = $root.find('.gallery-slider__slider');
    const sliderItems = $slider.find('.gallery-slider__item').get();
    const next = $root.find('.gallery-slider__nav .swiper-arrow--next')[0];
    const prev = $root.find('.gallery-slider__nav .swiper-arrow--prev')[0];

    const swiper = new Swiper($slider[0], {
        modules: [Navigation, EffectCoverflow],
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        coverflowEffect: {
            rotate: 0,
            stretch: 100,
            scale: 0.432,
            slideShadows: false,
        },
    });

    const $views = $root.find('.gallery-slider__view');
    $views.on('click', ev => {
        ev.preventDefault();
        ev.stopPropagation();

        const $target = $(ev.currentTarget);
        const href = $target.attr('href');

        const items = sliderItems.map(elem => {
            const $item = $(elem);
            const $img = $item.find('.gallery-slider__image');
            const $view = $item.find('.gallery-slider__view');
            return {
                src: $view.attr('href'),
                alt: $img.attr('alt') || '',
                title: $view.attr('title') || '',
                current: href === $view.attr('href'),
            };
        });

        const dialog = new Dialog({
            type: 'image',
            items: items,
            $navNext: $(next).clone().removeClass('swiper-button-disabled'),
            $navPrev: $(prev).clone().removeClass('swiper-button-disabled'),
            loop: swiper.params.loop,
        });
        dialog.open();

        dialog.on('dialog:prev', () => {
            swiper.slidePrev();
        });
        dialog.on('dialog:next', () => {
            swiper.slideNext();
        });

    });

});
